<template>
  <div class="form-container">
    <div class="form-group" v-if="filesWithTag.length > 0">
      <h5>Files with Tag</h5>
      <div class="files-with-tag-container">
        <span v-for="file in filesWithTag" :key="file.key" class="file-with-tag">
            {{ file.alias }}
        </span>
      </div>
    </div>
    <div class="form-group">
      <form @submit.prevent="updateTag">
        <div class="action-container">
          <input
            type="text"
            id="tag-name-input"
            class="form-control"
            :placeholder="tagName"
            autocomplete="off"
            spellcheck="false"
            v-model="localTagName"
            @input="error = ''"
            required
          />
          <div
            v-if="deletePermission"
            @click="showDeleteModal = true"
            class="delete-icon icon">
          </div>
          <Modal
            title="Delete Tag"
            :show="showDeleteModal"
            @close="showDeleteModal = false"
          >
            <DeleteTag
              :tagId="tagId"
              :tagName="tagName"
              :successCallback="onDeleteTag"
            ></DeleteTag>
          </Modal>
        </div>
        <span
          v-if="!isFieldValid"
          class="info">
          Tag name must be at least 3 characters long.
        </span>
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="!isFieldValid"
        >
          <span>Update Tag</span>
        </button>
      </form>
      <span class="error-message" v-if="error">{{ error }}</span>
    </div>
  </div>
</template>
<script>
import dynamoDB from '@/aws/aws-dynamoDB';

import Modal from '@/components/modal.vue';
import DeleteTag from '@/components/tag-delete.vue';

export default {
  components: {
    Modal,
    DeleteTag,
  },
  props: {
    tagId: {
      type: String,
      required: true,
    },
    tagName: {
      type: String,
      required: true,
    },
    deletePermission: {
      type: Boolean,
      default: false,
    },
    successCallback: {
      type: Function,
      default: e => e,
    },
    deleteCallback: {
      type: Function,
      default: e => e,
    },
  },
  data() {
    return {
      error: '',
      localTagName: this.tagName,
      filesWithTag: [],
      showDeleteModal: false,
    };
  },
  computed: {
    isFieldValid() {
      return this.localTagName.length >= 3;
    },
  },
  async created() {
    this.filesWithTag = await dynamoDB.getDBFilesByTags(this.tagId);
  },
  methods: {
    async updateTag() {
      const res = await dynamoDB.updateDBTag(this.tagId, this.localTagName);

      if (res.$metadata.httpStatusCode === 200) {
        this.successCallback(res);
      } else {
        this.error = res.message;
      }
    },
    onDeleteTag() {
      this.showDeleteModal = false;
      this.deleteCallback();
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .form-container
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    padding: 15px 10px
    flex-wrap: wrap;
    gap: 1rem;
    width: 100%

    .form-group
      display: flex
      flex-direction: column
      align-items: center
      justify-content: center
      gap: 5px

    h5
      margin-top: 1.5rem
      margin-bottom: 0.5rem

    form
      display: flex
      flex-direction: column
      align-items: center
      justify-content: center
      margin-top: 2rem
      gap: 1rem

      input
        font-size: 1.5rem
        padding: 1.3rem 1.5rem
        border-radius: .5rem
        border: 1px solid $black60
        font-family: space-grotesk
        min-width: 230px

        &:focus
          outline: none
          border: 1px solid $primary-color

      .action-container
        display: flex
        flex-flow: row nowrap
        gap: 2rem
        align-items: center

      .info
        color: $black30
        font-size: 1.2rem

      button[type="submit"]
        background-color: $primary-color
        color: $white
        font-size: 1.7rem
        padding: 1.3rem 2.5rem
        border: none
        border-radius: .5rem
        cursor: pointer
        transition: background-color 0.3s ease-in-out

        &:hover
          background-color: darken($primary-color, 10%)

        &:disabled
          /* Disabled state styles */
          background-color: $secondary-color;
          cursor: not-allowed;
  .error-message
    color: red
    margin-top: 0.5rem
    font-size: 1.2rem

  .files-with-tag-container
    display: flex
    flex-direction: row
    flex-wrap: wrap
    justify-content: center
    align-items: center
    gap: .4rem
    width: 60rem

    .file-with-tag
      color: $black60
      background-color: $secondary-color
      padding: .3rem 2rem
      max-width: 25rem
      font-size: 1.5rem
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap

  .icon
    width: 30px
    height: 30px
    background-size: contain
    cursor: pointer

  .delete-icon
    background: url('../assets/delete_document.svg') no-repeat


</style>
